import { queryClient } from "@/queryClient"
import { api } from "@/api"

export type CreateCategoryQuery = {
  name: string
  parentCategoryId: string | null
  color: string | null
}

export const createCategory = async (
  params: CreateCategoryQuery
): Promise<undefined> => {
  await api.post<unknown>("/products/categories/", {
    body: params,
  })

  queryClient.invalidateQueries({
    queryKey: [BASE_CATEGORIES_QUERY_KEY],
  })
  return
}
